import { Component } from '@angular/core'
import { SignupFlowService } from '@flowaccount/landing'
import { SignupPreviousPath } from '../../../../enum/landing-enum'
import { TranslateService } from '@ngx-translate/core'

@Component({
  selector: 'flowaccount-tax-invoice-intro',
  templateUrl: './tax-invoice-intro.component.html',
  styleUrls: ['./tax-invoice-intro.component.scss'],
})
export class TaxInvoiceIntroComponent {
  public getAltText = this.translate.currentLang === 'th' ? 'ทำใบกำกับภาษีบนมือถือ' : 'Mobile Tax Invoice Creation'
  constructor(public translate: TranslateService, private signupFlowService: SignupFlowService) {}

  onSignupEvent(): void {
    this.signupFlowService.setCookie(SignupPreviousPath.TAX_INVOICE, true)
  }
}
